import { Button, Stack, Tab, Tabs } from "@mui/material";
import { AddResourceLayout } from "./add-resource-layout";
import { AddLeonardoResourceLayout } from "./add-leonardo-resource-layout";
import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
var TabValue;
(function (TabValue) {
    TabValue[TabValue["AddLeonardoResource"] = 0] = "AddLeonardoResource";
    TabValue[TabValue["AddCommonResource"] = 1] = "AddCommonResource";
})(TabValue || (TabValue = {}));
export const AddResourcePage = () => {
    const navigate = useNavigate();
    const [currentTab, setCurrentTab] = React.useState(TabValue.AddLeonardoResource);
    const handleTabChange = useCallback((event, newValue) => {
        setCurrentTab(newValue);
    }, []);
    const handleGoBack = useCallback(() => {
        navigate("/");
    }, [history]);
    return (React.createElement(Stack, { direction: "column", alignItems: "center", padding: 3, spacing: 4, style: { flex: 1, overflow: "hidden" } },
        React.createElement(Tabs, { variant: "fullWidth", value: currentTab, onChange: handleTabChange },
            React.createElement(Tab, { value: TabValue.AddLeonardoResource, label: "Add Leonardo Resource" })),
        currentTab === TabValue.AddLeonardoResource && (React.createElement(AddLeonardoResourceLayout, null)),
        currentTab === TabValue.AddCommonResource && React.createElement(AddResourceLayout, null),
        React.createElement(Button, { variant: "contained", onClick: handleGoBack, sx: { textTransform: "none" } }, "Back")));
};
